<template>
  <div>
    <section class="section--pt-lg">
      <div class="inner">
        <h2 class="Head__blue">
          お気に入りクラス
        </h2>
        <p class="_mg-b15 _l-lg">
          クラスをお気に入り登録すると、クラス開催前日にお知らせが届くようになります。
          <br>お知らせの設定を変える場合は<router-link to="/change/notification/" class="Link__line">
            こちら
          </router-link>
        </p>
        <div
          class="Btn Btn__dotted Btn__dotted--black"
          data-modal-open="class02"
          @click="openModal()"
        >
          クラス内容の確認はこちら
        </div>
        <!-- <class-favorite-list :is-open="isFavoriteList" @close="isFavoriteList = false" @changeCategory="changeCategory($event)" /> -->
        <div class="CheckList__area">
          <div
            v-for="program in listPrograms"
            v-show="program.display_status == 1"
            :key="program.id"
            class="CheckList__box"
          >
            <label
              class="Check__box Check__box__lightblue _ft-spacing60"
            ><input
              v-model="program.is_favorite_user"
              type="checkbox"
              name="class"
              @click="changeCategoryClass(program.id)"
            ><span
              class="Check__box_inner"
            /><span class="Check__box_inner_tx" style="text-transform:capitalize;">{{ program.name }}</span></label>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
// import ClassFavoriteList from './ClassFavoriteModal/ClassFavoriteList.vue'
import programcategoryService from '@/services/programcategoryService'
import favoriteService from '@/services/favoriteService'
export default {
  name: 'ClassFavorite',
  // components: { ClassFavoriteList },
  data() {
    return {
      isFavoriteList: false,
      listPrograms: {}
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getListPrograms()
    },
    async getListPrograms() {
      const response = await programcategoryService.index()
      this.listPrograms = response.data
    },
    async changeCategoryClass(id) {
      await favoriteService.addCategoryFavorite(id)
      this.$emit('reloadModal')
    },
    openModal() {
      this.$emit('modalClass')
    }
  }
}
</script>
